import { Card, CardBody, CardHeader } from 'reactstrap';
import { Alert, AlertTitle, Typography } from '@mui/material';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { ImageList, ImageListItem } from '@mui/material';
import { BiRightArrow } from 'react-icons/bi'
import paproy from './Recursos/Proceso_aprobacion_proyectos2019.png'
import paprop from './Recursos/Proceso_aprobacion_propuestas2019.png'
import CardIcono from './Icono/CardIcono';
import icono12 from '../recursos_iconos/Acceso-BD.svg'
import icono13 from '../recursos_iconos/AcreditacionMAS.svg'
import icono2 from '../recursos_iconos/AreaPRIORITARIA.svg'
import icono1 from '../recursos_iconos/Contacto DECANATO.svg'
import icono10 from '../recursos_iconos/ESPOL-investigacion.svg'
import icono5 from '../recursos_iconos/GESTIONproyectos.svg'
import icono7 from '../recursos_iconos/IRESEARCH.svg'
import icono4 from '../recursos_iconos/ProcesosINVESTIGACION.svg'
import icono11 from '../recursos_iconos/SciVAL.svg'
import icono15 from '../recursos_iconos/calendario-EVENTOS.svg'
import icono9 from '../recursos_iconos/catalago-INVESTIGACION.svg'
import icono3 from '../recursos_iconos/reglamento-RESOLUSIONES.svg'
import icono14 from '../recursos_iconos/comite-ETICA.svg'
import icono6 from '../recursos_iconos/consulta-PROYECTOS.svg'
import icono8 from '../recursos_iconos/grupo-INVESTIGACION.svg'
import icono16 from '../recursos_iconos/Dashboard.svg'
import icono17 from '../recursos_iconos/ayud.svg'
import vacaciones from '../componentes/Recursos/vacacionesInv.jpeg'
import './Icono/cardIcon.css';
import Grid from '@mui/material/Grid';
import ImageModal from './Common/ImagenModal';
import { useEffect, useState } from 'react';
const Front: string = process.env.REACT_APP_FRONT || '';
const gestion = 'https://gestionproyectos.espol.edu.ec';
const portal = 'https://investigacion.espol.edu.ec';
const ayud = 'https://ayudantias.espol.edu.ec/';
const iconos = [
    {
        imagen: icono10,
        texto: "ESPOL y su Investigación",
        backColor: "#307aff",
        backColorDeshabilitado: "#C4C3C3",
        enlace: "https://www.espol.edu.ec/sites/default/files/investigacion/2025/ESPOL%20y%20su%20investigación/ESPOLInvestigación_completoBJ.pdf",
        habilitar: true
    },
    {
        imagen: icono1,
        texto: "Contactos Decanato",
        backColor: "#e9b300",
        backColorDeshabilitado: "#C4C3C3",
        enlace: "https://www.espol.edu.ec/es/investigacion",
        habilitar: true
    },
    {
        imagen: icono2,
        texto: "Areas prioritarias",
        backColor: "#e07a2e",
        backColorDeshabilitado: "#C4C3C3",
        enlace: "https://www.espol.edu.ec/es/investigacion/areas-prioritarias",
        habilitar: true
    },
    {
        imagen: icono3,
        texto: "Reglamentos y resoluciones de Investigación",
        backColor: "#de5a5a",
        backColorDeshabilitado: "#C4C3C3",
        enlace: "https://www.espol.edu.ec/es/investigacion/reglamentos",
        habilitar: true
    },
    {
        imagen: icono4,
        texto: "Procesos de Investigación",
        backColor: "#eeacac",
        backColorDeshabilitado: "#C4C3C3",
        enlace: "https://www.espol.edu.ec/index.php/es/investigacion/procesos",
        habilitar: true
    },
    {
        imagen: icono5,
        texto: "Plataforma de Gestión de Proyectos",
        backColor: "#ee53ac",
        backColorDeshabilitado: "#C4C3C3",
        enlace: gestion,
        habilitar: true
    },
    {
        imagen: icono17,
        texto: "Plataforma de Ayudantías",
        backColor: "#26224E",
        backColorDeshabilitado: "#C4C3C3",
        enlace: ayud,
        habilitar: true
    },
    {
        imagen: icono6,
        texto: "Consulta de Proyectos",
        backColor: "#953462",
        backColorDeshabilitado: "#C4C3C3",
        enlace: "https://www.espol.edu.ec/es/investigacion/programas-proyectos",
        habilitar: true
    },

    {
        imagen: icono7,
        texto: "i-Research",
        backColor: "#603462",
        backColorDeshabilitado: "#C4C3C3",
        enlace: "http://i-research.espol.edu.ec/",
        habilitar: true
    },
    {
        imagen: icono8,
        texto: "Centros y grupos de Investigación",
        backColor: "#535d8f",
        backColorDeshabilitado: "#C4C3C3",
        enlace: "https://www.espol.edu.ec/es/investigacion/unidades-investigacion",
        habilitar: true
    },

    {
        imagen: icono9,
        texto: "Catálogo de Laboratorios",
        backColor: "#478db0",
        backColorDeshabilitado: "#C4C3C3",
        enlace: "http://www.lab.espol.edu.ec/",
        habilitar: true
    },
    {
        imagen: icono11,
        texto: "SciVal",
        backColor: "#34c463",
        backColorDeshabilitado: "#C4C3C3",
        enlace: "https://scival.com",
        habilitar: true
    },
    {
        imagen: icono12,
        texto: "Acceso a Base de Datos Científicas",
        backColor: "#00b5b8",
        backColorDeshabilitado: "#C4C3C3",
        enlace: "http://www.cib.espol.edu.ec/basesdedatos_suscritas",
        habilitar: true
    },

    {
        imagen: icono13,
        texto: "Registro, acreditación y categorización en Senescyt",
        backColor: "#0086b8",
        backColorDeshabilitado: "#C4C3C3",
        enlace: "http://acreditacioninvestigadores.senescyt.gob.ec/",
        habilitar: true
    },
    {
        imagen: icono14,
        texto: "Comité de ética",
        backColor: "#3a5cd6",
        backColorDeshabilitado: "#C4C3C3",
        enlace: Front + "inicio/comite-etica",
        habilitar: true
    },
    {
        imagen: icono15,
        texto: "Calendario de eventos",
        backColor: "#254193",
        backColorDeshabilitado: "#C4C3C3",
        enlace: Front + "inicio/CalendarioInvestigacion",
        habilitar: true
    },

    {
        imagen: icono16,
        texto: "Visualización - período de evaluación",
        backColor: "#254156",
        backColorDeshabilitado: "#C4C3C3",
        enlace: Front + "periodoevaluacion",
        habilitar: true,
        toolTipText: "Actualización/mantenimiento de la opción"
    },
];
export default function Portal() {
    const [popUpOpen, setPopUpOpen] = useState<boolean>(false);

    const cerrarModal = (estado: boolean) => {
        setPopUpOpen(estado);
    };

    useEffect(() => {
        const maxDate = new Date('2025-03-04T23:59:59');
        compareDateAndExecute(maxDate);
    },[]);

    const compareDateAndExecute = (maxDate: Date) => {
        const now = new Date();
        if (now <= maxDate) {
          setPopUpOpen(true);
        } else {
          console.log('La fecha actual es posterior a la fecha máxima. No se ejecutará nada.');
        }
    };

    return (
        <>
            <Grid className='centrado_centro' container spacing={{ xs: 3, md: 6 }} columns={{ xs: 1, sm: 2, md: 4 }}>
                {
                    iconos.map(icono => (
                        <Grid item key={icono.texto}>
                            <CardIcono
                                imagen={icono.imagen}
                                texto={icono.texto}
                                backColor={icono.backColor}
                                enlace={icono.enlace}
                                habilitar={icono.habilitar}
                                backColorDeshabilitar={icono.backColorDeshabilitado}
                                toolTipText={icono.toolTipText}
                            />
                        </Grid>
                    ))
                }
            </Grid>
            <ImageModal imagen={vacaciones} enlace='' isOpen={popUpOpen} cerrarModal={cerrarModal} />
        </>
    )
}